import script from "./undoButton.vue?vue&type=script&setup=true&lang=js"
export * from "./undoButton.vue?vue&type=script&setup=true&lang=js"

import "./undoButton.vue?vue&type=style&index=0&id=32f5a166&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f5a166"]])

export default __exports__